import instance from "../instance";


export const dataApi = {
  getData: (query, name, lang, otherQuery = '') => {
    return instance.get(`/v1/rd/data/${query}?verbose_level=2&limit=20${name ? `&name=${name}` : ''}${otherQuery}`, {
      headers: {
        'Accept-Language': lang
      }
    })
  },
  createModel: (name, shipyard_id, yacht_type_id, length, width) => {
    console.log(`/v1/rd/data/yacht-models`, {
      name, shipyard_id, yacht_type_id, length, width
    })
    return instance.post(`/v1/rd/data/yacht-models`, {
      name, shipyard_id, yacht_type_id, length, width
    }, {
      headers: {
        'Content-Type': "application/json"
      }
    })
  },
  addYacht: ({name, year, yacht_model_id, operator_id, yacht_owner_name, isPrivateOwn, yacht_type_id, yacht_image_id, editYachtId}) => {
    let body = {name, year, yacht_model_id, yacht_type_id, yacht_image_id}
    if(isPrivateOwn) {
      body = {...body, yacht_owner_name}
    } else {
      body = {...body, operator_id}
    }
    body = Object.fromEntries(Object.entries(body).filter(([_, v]) => (v !== null && v !== undefined && v !== '')));
    if(editYachtId) {
      return instance.patch(`/v1/rd/data/yachts/${editYachtId}?verbose_level=2`, body)
    } else {
      return instance.post(`/v1/rd/data/yachts?verbose_level=2`, body)
    }
  }
}
